import type { ReactNode } from 'react';

type Props = {
  title?: ReactNode;
  toolbar?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
};

export function Card({ title, toolbar, children, className = '', bodyClassName = '' }: Props) {
  const hasHeader = Boolean(title) || Boolean(toolbar);
  return (
    <div className={`card pk-card ${className}`.trim()}>
      {hasHeader ? (
        <div className="card-header">
          {title ? <h3 className="card-title">{title}</h3> : <span />}
          {toolbar ? <div className="card-toolbar">{toolbar}</div> : null}
        </div>
      ) : null}
      <div className={`card-body ${bodyClassName}`.trim()}>{children}</div>
    </div>
  );
}
